"use client";

import styled, { useTheme } from "styled-components";
import WarningIcon from "@/assets/icons/WarningIcon.svg";
import Button from "../Button/Button";
import { useTranslations } from "next-intl";
import { useBoundStore } from "@/lib/stores/useBoundStore";
import { Icon } from "../Icon/Icon";
import { useParams, useRouter } from "next/navigation";

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  .icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  h2 {
    font-size: 2rem;
    font-weight: normal;
    color: ${(props) => props.theme.black};
  }

  p {
    font-size: 1rem;
    color: ${(props) => props.theme.black};
    margin: 0;
    line-height: normal;

    span {
      font-weight: bold;
    }
  }
`;

const Footer = styled.div`
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
  gap: 20px;
`;

export function UnsavedChangesContent() {
  const theme = useTheme();
  const router = useRouter();
  const t = useTranslations("adminOrganizationsPage");
  const params = useParams<{ orgId: string }>();

  const pendingNavigation = useBoundStore((s) => s.pendingNavigation);
  const handleCloseAdminModal = useBoundStore((s) => s.handleCloseAdminModal);
  const setOrgProfileMode = useBoundStore((s) => s.setOrgProfileMode);
  const setUserProfileMode = useBoundStore((s) => s.setUserProfileMode);
  const setSelectedAdminOrg = useBoundStore((s) => s.setSelectedAdminOrg);
  const setSelectedOrgId = useBoundStore((s) => s.setSelectedOrgId);
  const setIsEditCareplan = useBoundStore((s) => s.setIsEditCareplan);
  const setIsCreateOrgCareplan = useBoundStore((s) => s.setIsCreateOrgCareplan);
  const setIsPredefinedMenuOpen = useBoundStore(
    (s) => s.setIsPredefinedMenuOpen,
  );

  const handleCancel = () => {
    handleCloseAdminModal();
  };

  const handleContinue = () => {
    if (!pendingNavigation) return;
    setOrgProfileMode("view");
    setUserProfileMode("view");
    setIsEditCareplan(false);
    setIsCreateOrgCareplan(false);
    setIsPredefinedMenuOpen(false);
    if (!pendingNavigation.includes(`/admin/organizations/${params.orgId}/`)) {
      setSelectedAdminOrg(null);
      setSelectedOrgId("");
    }
    router.push(pendingNavigation);
    handleCloseAdminModal();
  };

  return (
    <>
      <Body>
        <div className="icon-container">
          <Icon
            url={WarningIcon.src}
            color="#ACACAC"
            height="65px"
            width="65px"
          />
        </div>
        <h2 className="johnson-display">{t("unsavedChanges.title")}</h2>
        <p>
          {t("unsavedChanges.message")}&nbsp;
          <span>{t("unsavedChanges.areYouSure")}</span>
        </p>
      </Body>
      <Footer>
        <Button
          label={t("unsavedChanges.cancel")}
          name="cancel-navigation"
          theme="tertiary"
          onPress={handleCancel}
        />
        <Button
          label={t("unsavedChanges.continue")}
          name="confirm-navigation"
          theme="primary"
          onPress={handleContinue}
        />
      </Footer>
    </>
  );
}
